import { render, staticRenderFns } from "./MainCart.vue?vue&type=template&id=e9e4c234&scoped=true&"
import script from "./MainCart.vue?vue&type=script&lang=ts&"
export * from "./MainCart.vue?vue&type=script&lang=ts&"
import style0 from "./MainCart.vue?vue&type=style&index=0&id=e9e4c234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e4c234",
  null
  
)

export default component.exports